import React from "react";
import styled from "styled-components";
import tw from "tailwind.macro";
import { Parallax } from "react-spring/addons.cjs";

// Components
import Layout from "../components/Layout";
import ProjectCard from "../components/ProjectCard";

// Elements
import Inner from "../elements/Inner";
import { Title, TitleDark, BigTitle, Subtitle } from "../elements/Titles";

// Views
import Hero from "../views/Hero";
import Services from "../views/Services";
import Projects from "../views/Projects";
import About from "../views/About";
import Contact from "../views/Contact";

import avatar from "../images/avatar.jpg";

// Material UI
import {
  MuiThemeProvider,
  createMuiTheme,
  withStyles
} from "@material-ui/core/styles";
import grey from "@material-ui/core/colors/grey";
import AppBar from "@material-ui/core/AppBar";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import Button from "@material-ui/core/Button";

const theme = createMuiTheme({
  palette: {
    primary: {
      main: "#512da8"
    },
    secondary: grey
  },
  typography: {
    useNextVariants: true
  }
});

const ProjectsWrapper = styled.div`
  ${tw`flex flex-wrap justify-between mt-8`};
  display: grid;
  grid-gap: 4rem;
  grid-template-columns: repeat(2, 1fr);
  @media (max-width: 1200px) {
    grid-gap: 3rem;
  }
  @media (max-width: 900px) {
    grid-template-columns: 1fr;
    grid-gap: 2rem;
  }
`;

const AboutHero = styled.div`
  ${tw`flex flex-col lg:flex-row items-center mt-8`};
`;

const Avatar = styled.img`
  ${tw`rounded-full w-48 xl:w-64 shadow-lg h-auto`};
`;

const AboutSub = styled.span`
  ${tw`text-white pt-12 lg:pt-0 lg:pl-12 text-2xl lg:text-3xl xl:text-4xl`};
`;

const AboutDesc = styled.p`
  ${tw`text-grey-light text-lg md:text-xl lg:text-2xl font-sans pt-6 md:pt-12 text-justify`};
`;

const ContactText = styled.p`
  ${tw`text-grey-dark font-sans text-xl md:text-2xl lg:text-3xl`};
`;

const Footer = styled.footer`
  ${tw`text-center text-grey absolute pin-b p-6 pb-24 font-sans text-md lg:text-lg`};
`;

const StyledAppBar = withStyles({
  root: {
    borderBottomLeftRadius: 24,
    borderBottomRightRadius: 24
  }
})(AppBar);

const StyledTabs = withStyles({
  indicator: {
    background: "#f5f5f5"
  }
})(Tabs);

const StyledTab = withStyles({
  textColorInherit: "#f5f5f5"
})(Tab);

class Index extends React.Component {
  state = {
    index: 0
  };

  render() {
    const { index } = this.state;
    return (
      <MuiThemeProvider theme={theme}>
        <Layout />
        <div style={{ display: "flex", flex: 1 }}>
          <StyledAppBar position="sticky" color="primary">
            <StyledTabs
              centered={true}
              value={index}
              onChange={(event, value) => this.setState({ index: value })}
            >
              <StyledTab
                label="Welcome"
                onClick={() => this.parallax.scrollTo(0)}
              />
              <StyledTab
                label="Services"
                onClick={() => this.parallax.scrollTo(1)}
              />
              <StyledTab
                label="Projects"
                onClick={() => this.parallax.scrollTo(2)}
              />
              <StyledTab
                label="About"
                onClick={() => this.parallax.scrollTo(3)}
              />
            </StyledTabs>
          </StyledAppBar>
          <Parallax ref={parallax => (this.parallax = parallax)} pages={5}>
            <Hero offset={0}>
              <BigTitle>
                Welcome, <br /> I'm Cheng Sokdara.
              </BigTitle>
              <Subtitle>
                Lead developer of RaWeWhat Team, we're creating web and mobile
                application in lighting speed with exceptional quality.
              </Subtitle>
              <Button
                variant="contained"
                color="primary"
                size="large"
                onClick={() => this.parallax.scrollTo(4)}
              >
                Contact Us
              </Button>
            </Hero>
            <Services offset={1}>
              <Title>Services</Title>
              <AboutDesc>Coming Soon.</AboutDesc>
            </Services>
            <Projects offset={2}>
              <Title>Projects</Title>
              <ProjectsWrapper>
                <ProjectCard
                  title="Project OneShot"
                  link="https://www.google.com"
                  bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)"
                >
                  This project is currently developing in secrecy.
                </ProjectCard>
                <ProjectCard
                  title="Khmer Live TV"
                  link="https://play.google.com/store/apps/details?id=com.daradev.tv"
                  bg="linear-gradient(to right, #662D8C 0%, #ED1E79 100%)"
                >
                  The first project that I start to use Firebase for backend,
                  and also mark my new design inspired by Material Design.
                </ProjectCard>
                <ProjectCard
                  title="Khmer Font Store"
                  link="https://play.google.com/store/apps/details?id=com.daradev.fontstore"
                  bg="linear-gradient(to right, #009245 0%, #FCEE21 100%)"
                >
                  Created to compliment my early app, it showcase my use of
                  Laravel as server side database.
                </ProjectCard>
                <ProjectCard
                  title="Khmer Unicode Installer"
                  link="https://play.google.com/store/apps/details?id=com.blogspot.androidsanctum.kui"
                  bg="linear-gradient(to right, #D585FF 0%, #00FFEE 100%)"
                >
                  The first successful project started in 2012, it was my most
                  profitable app even until today.
                </ProjectCard>
              </ProjectsWrapper>
            </Projects>
            <About offset={3}>
              <Title>About</Title>
              <AboutHero>
                <Avatar src={avatar} alt="Cheng Sokdara" />
                <AboutSub>
                  Born and raised in Cambodia, but my work ethnic and way of
                  life is of a Japanese. Easy going at everyday life but super
                  serious when working. Quick learner and easy adaptable.
                </AboutSub>
              </AboutHero>
              <AboutDesc>
                I am more of a all-in-one guy who do everything by myself. I
                self develop all of my three apps above, from brainstorming
                ideas, design the UI/UX, actual code development and goes all
                the way to marketing the app. My best quality is my quick
                learning intuition and my razor sharp focus whenever I am
                working. Everyday I keep on learning new technology and always
                in constant searching for an easier way to do my job.
              </AboutDesc>
            </About>
            <Contact offset={4}>
              <Inner>
                <TitleDark>Get in touch</TitleDark>
                <ContactText>
                  Say <a href="mailto:chengsokdara@gmail.com">Hi</a> or find me
                  on other platforms:{" "}
                  <a href="https://www.linkedin.com/in/chengsokdara/">
                    LinkedIn
                  </a>{" "}
                  or <a href="https://www.facebook.com/homi3">Facebook</a>
                </ContactText>
              </Inner>
              <Footer>
                &copy; 2019{" "}
                <a href="https://github.com/rawewhat-team" target="_blank">
                  RaWeWhat Team.
                </a>
                <br />
                by{" "}
                <a href="https://www.facebook.com/homi3" target="_blank">
                  Cheng Sokdara
                </a>
                .
              </Footer>
            </Contact>
          </Parallax>
        </div>
      </MuiThemeProvider>
    );
  }
}

export default Index;
